module.exports = __webpack_public_path__ + "static/media/icon-balcon-dark.ae79a9a1.svg";